<template>
  <div style="margin: 25px">
    <vue-good-table
      :columns="sozlesmecolumns"
      :rows="sozlesmeList"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-row>
              <b-col lg="12" sm="12">
                <vs-button
                  @click="alimSec()"
                  color="success"
                  type="flat"
                  size="small"
                  icon="done"
                ></vs-button>
              </b-col>
            </b-row>
          </span>
        </span>
      </template>

      <!-- pagination -->
    </vue-good-table>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      dir: false,
      sozlesmeList: [],
      sozlesmecolumns: [
        {
          label: "Cari Adı",
          field: "ACTNAME",
        },
        {
          label: "Açıklama",
          field: "REZERVEC1",
        },
        {
          label: "Başlama",
          field: "CONTSTARTDATE",
        },
        {
          label: "Bitiş",
          field: "CONTFINISHDATE",
        },
        {
          label: "Fiyat",
          field: "PRICE",
        },
        {
          field: "action",
          label: "Seç",
        },
      ],
      hareketList: [],
    };
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    alimSec() {},
    sozlesmeler() {
      var vm = this;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_Sozlesmeler(args, function (err, result) {
          if (result.INT_Ls_Stock_SozlesmelerResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Stock_SozlesmelerResult);
          vm.sozlesmeList = vm.veriler;
          // vm.rowData = vm.veriler;
        });
      });
    },
  },
  created() {
    this.sozlesmeler();
  },
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>